import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "./client";

/**
 * Escape hatch ÚNICO para tabelas/colunas ainda fora dos types auto-gerados
 * do Supabase (meals_consumed, water_intake_log, colunas push_* /
 * tracking_agua_ativo / novo_fracionamento / avatar_id de users_app...).
 *
 * Antes disso cada call-site fazia `(supabase.from('x' as any) as any)` —
 * 8 hatches espalhados. Centralizar aqui deixa o lint limpo e dá UM lugar
 * pra deletar quando rodarmos `supabase gen types` (follow-up em
 * docs/ISSUES.md do workspace).
 *
 * É o MESMO client de runtime — só o schema genérico (untyped) do TS.
 */
export const fromUntyped = (table: string) =>
  (supabase as unknown as SupabaseClient).from(table);
